import { Droppable } from "react-beautiful-dnd";
import styled from "styled-components";

export const DraggableItem = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: start;
    text-align: start;
    border: none;
    width: fit-content;
    font-weight: bold;
    background-color: ${props => props.theme.colors.inputBackground};
    border-radius: 8px;
    width: 100%;
    padding: 16px;

    ${props => props.theme.mediaQuerie.maxWidth.sm}{
        margin-bottom: 16px;
    }

    cursor: pointer;
`;